import React, { useEffect, useState } from "react";
import MaterialSelect from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import { getCountryList } from "Network/Core/CountryUom/CountryUom";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";

interface Country {
    code: string;
    name: string;
}

interface CountrySelectProps {
    value?: string;
    onChange?: (value: string) => void;
}

export default function CountrySelect({ value = "", onChange }: CountrySelectProps) {
    const [options, setOptions] = useState<Country[]>([]);
    const region = getLocalStorage(ls_vars.REGION_ID);

    useEffect(() => {
        const fetchCountries = async () => {
            const response = await getCountryList(region);
            if (response?.data && Array.isArray(response.data)) {
                setOptions(response.data);
            }
        };
        fetchCountries();
    }, []);

    const handleChange = (event: any) => {
        const selectedValue = event.target.value;
        const selectedCountry = options.find((option: Country) => option.name === selectedValue);
        onChange?.(selectedCountry?.name || selectedValue);
    };

    return (
        <MaterialSelect
            style={{ width: "22rem" }}
            inputProps={{
                id: "country",
                name: "country",
                required: true,
                className: "form-control",
            }}
            value={options.find((option: Country) => option.name === value)?.name || ""}
            onChange={handleChange}
        >
            {Array.isArray(options) && options.map((item: Country) => (
                <MenuItem key={item.code} value={item.name}>
                    {item.name}
                </MenuItem>
            ))}
        </MaterialSelect>
    );
}
